module.exports = __webpack_public_path__ + "img/viewingPhone.8fe8aea1.png";